import { FadeInOnScroll } from "@/design-system/motion/FadeInOnScroll";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQSection() {
  const { t } = useTranslation("landing");
  const faqs = t("faq.items", { returnObjects: true }) as Array<{ q: string; a: string }>;

  return (
    <section id="faq" className="py-24 md:py-32 bg-muted/20">
      <div className="max-w-3xl mx-auto px-6">
        <FadeInOnScroll>
          <p className="text-sm text-muted-foreground tracking-widest uppercase mb-4">{t("faq.badge")}</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            {t("faq.headline")}
          </h2>
        </FadeInOnScroll>

        <FadeInOnScroll delay={100}>
          <Accordion type="single" collapsible className="mt-10 w-full space-y-2">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-border px-0"
              >
                <AccordionTrigger className="text-left text-foreground font-medium py-5 hover:no-underline text-sm">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeInOnScroll>
      </div>
    </section>
  );
}

// Structured data export for SEO — uses English as canonical
export const FAQ_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    { "@type": "Question", "name": "What is Lombrici?", "acceptedAnswer": { "@type": "Answer", "text": "A white-label AI platform you launch under your own brand. Currently in beta with 4 Suites and 11 AI Flows, including billing and client management." } },
    { "@type": "Question", "name": "Do clients see it's Lombrici?", "acceptedAnswer": { "@type": "Answer", "text": "No. Your logo, colors, domain. Lombrici is invisible to your clients." } },
    { "@type": "Question", "name": "Do I need technical knowledge?", "acceptedAnswer": { "@type": "Answer", "text": "No. We guide you through setup. Add branding, choose modules, go live." } },
    { "@type": "Question", "name": "Can I cancel monthly?", "acceptedAnswer": { "@type": "Answer", "text": "Yes. No contracts, no hidden costs." } },
    { "@type": "Question", "name": "Is the platform fully ready?", "acceptedAnswer": { "@type": "Answer", "text": "Lombrici is in public beta. The core — Suites, Flows, Billing, White-label — works. We're actively building new features." } },
    { "@type": "Question", "name": "Can I set my own prices?", "acceptedAnswer": { "@type": "Answer", "text": "Yes. Billing via Stripe goes directly to your account." } },
  ],
};
